export const CONFIGURATION_PARAMETERS = {
    ACTIVE_MODULES: {
        CLINICAL_MODULE: 'configuration.parameter.laboratory.module.registry.request.active'
    }
}
